// Librerias
import React, { useState } from "react";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";
import Error from "../images/advertencia.png";

// Función para mensaje de error
const ErrorMessage = ({ estado }) => {
  const [showA, setShowA] = useState(true); //Almacena el estado del toast para activarlo

  const toggleShowA = () => setShowA(!showA); //Almacena el estado del toast para cerrarlo mediante click

  return (
    <>
      {estado && (
        <div>
          {/* <div class="alert alert-danger d-flex align-items-center position-absolute bottom-0 end-0" role="alert">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
          <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
        </svg>&nbsp;
        <div>
          Ha ocurrido un error, intente nuevamente.
        </div> */}

          <ToastContainer position="bottom-end" className="p-3">
            <Toast show={showA} onClose={toggleShowA}>
              <Toast.Header>
                <img
                  src={Error}
                  width="5%"
                  className="rounded me-2"
                  // alt=""
                />
                <strong className="me-auto">Error</strong>
                {/* <small className="text-muted">Just Now</small> */}
              </Toast.Header>
              <Toast.Body className="bg-light me-auto rounded">
                Ha ocurrido un error, intente nuevamente.
              </Toast.Body>
            </Toast>
          </ToastContainer>
        </div>
      )}
    </>
  );
};

export default ErrorMessage;